import registerRoutes from './routes';
import getUsers from './users/services/list/getUsers';
import addUserFactory from './users/services/add/addUser';
import editUserFactory from './users/services/edit/editUser';
import userDetailsFactory from './users/services/details/userDetails';
import deleteUserFactory from './users/services/delete/deleteUser';

export default function (app) {
    app.factory('getUsers', getUsers);
    app.factory('addUser', addUserFactory);
    app.factory('editUser', editUserFactory);
    app.factory('userDetails', userDetailsFactory);
    app.factory('deleteUser', deleteUserFactory);

    registerRoutes(app);
}



// WEBPACK FOOTER //
// ./Client/app/admin/index.js